// Klaro and the Emarsys script decide whether the campaigns come from Emarsys itself or
// from our web-channel fallback. Pages of the ClojureScript app render the fallback in
// `machtfit.startpage.emarsys`; the server-rendered pages render it in `emarsys-ribbons.js`,
// which reads the event and the last state. The app's deferred bundle runs before Klaro's
// `documentReady` setup, so the retry below is defensive.

export const WEB_CHANNEL_EVENT = "mf:emarsys-web-channel"
export const WEB_CHANNEL_STATE = "mfEmarsysWebChannel"

const CLJS_RETRY_MS = 1000
// `json_script` in `pages/startpage.html`, so only pages of the ClojureScript app wait for it.
const CLJS_PAGE_DATA = "startpage_cljs_data"

function cljsWillLoad() {
  return document.readyState === "loading" || document.getElementById(CLJS_PAGE_DATA) !== null
}

function callClojureScript(enabled) {
  const emarsys = window.machtfit?.startpage?.emarsys
  if (emarsys) {
    if (enabled) {
      emarsys.enable_web_channel_content()
    } else {
      emarsys.disable_web_channel_content()
    }
  } else if (cljsWillLoad()) {
    setTimeout(() => callClojureScript(enabled), CLJS_RETRY_MS)
  }
}

export function setWebChannel(enabled) {
  window[WEB_CHANNEL_STATE] = enabled
  window.dispatchEvent(new CustomEvent(WEB_CHANNEL_EVENT, { detail: { enabled } }))
  callClojureScript(enabled)
}
